import { render, staticRenderFns } from "./DspConfigurations.vue?vue&type=template&id=347eed61&lang=pug"
import script from "./DspConfigurations.vue?vue&type=script&lang=js"
export * from "./DspConfigurations.vue?vue&type=script&lang=js"
import style0 from "./DspConfigurations.vue?vue&type=style&index=0&id=347eed61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports